module.exports = JSON.parse('{"kd":"8c561b70-ad3b-47ae-9538-8eefef36966c"}')